import { post,postRequest, getRequest, deleteRequest } from '@/utils/axios'

  // --根据id查询实体
  export function GetCompanyById(query) {
    return post('/company/get/' + id, id)
  }

  //根据ID获取机构视图
export function GetCompany(query) {
    return post('/company/GetCompany', query)
  }

//编辑投保公司
  export function EditCompany(query) {
    return post('/company/EditCompany', query)
  }
  
//获取全部的直属伙伴(根据角色)
  export function GetCompanyListForSys(query) {
    return post('/company/GetCompanyListForSys', query)
  }


// WEBPACK FOOTER //
// ./src/api/company.js